import { LocalizedProperty } from "myfitworld-model";
import get from "lodash/get";

export default function (locale: string, property?: LocalizedProperty) {
  const langprop = property ? (get(property, locale) as string) : ""; // Assuming 'en' as fallback locale
  return langprop || (get(property, 'en') as string) || ""; 
}